import type { CompetitorTypes } from "~enums/competitorTypes";
import type { FixtureStatuses } from "~enums/fixtureStatuses";
import type { FixtureEntrant, TransformedFixtureData } from "~pages/Roster/FixtureRosterListPage/types/transformedFixtureData";
import type { Entity } from "~types/entity";
import type { Fixture, FixtureResources, FixtureResponse } from "~types/fixture";
import type { FixtureEntity } from "~types/fixtureEntity";

export const transformFixtureResponse = (
  response: FixtureResponse,
  buildFixtureName: (fixture: Fixture, resources: FixtureResources | undefined) => string,
): TransformedFixtureData => {
  const fixture: Fixture | undefined = response?.data?.[0];

  if (!fixture) {
    throw "Fixture does not exist in the fixture response";
  }

  const resources: FixtureResources | undefined = response.includes?.resources;
  const competitorType = fixture.competitorType as CompetitorTypes;

  const createFixtureEntityTransformed = (fixtureEntity: FixtureEntity, entity?: Entity): FixtureEntrant => {
    if (!entity) {
      throw new Error("Entity should be returned with FixtureEntity");
    }

    return {
      id: fixtureEntity.entityId,
      name: entity.nameFullLocal,
      nameAbbreviation: entity.codeLocal || entity.codeLatin || "",
      isHome: fixtureEntity.isHome ?? false,
    };
  };

  const competitorsTransformed =
    fixture.competitors?.map((x) => createFixtureEntityTransformed(x, resources?.entities?.[x.entity?.id])) ?? [];

  const fixtureProfile = resources?.fixtureProfiles?.[fixture?.profileId ?? ""];

  return {
    competitors: competitorsTransformed,
    competitorType: competitorType,
    fixtureName: buildFixtureName(fixture, resources),
    status: fixture.status as FixtureStatuses,
    fixtureProfile,
  };
};
